/**
 * Interface for the chat Redux state structure.
 */

import type { ChatConversation } from '../../interfaces/chat.interface'
import type { ChatMessageEntity, PaginationState } from './chat-message-entity.interface'

export interface ChatState {
  activeConversationId: string | null
  activeConversation: ChatConversation | null
  messageIdsByConversation: Record<string, string[]>
  messageEntities: Record<string, ChatMessageEntity>
  paginationByConversation: Record<string, PaginationState>
  pendingMessage: string
  locallyCreatedConversationIds: Record<string, boolean>
  lastReportCompletedAt: number
  isStoppingByConversationId: Record<string, boolean>
  isOrchestrationActiveByConversationId: Record<string, boolean>
}

export const createInitialChatState = (): ChatState => ({
  activeConversationId: null,
  activeConversation: null,
  messageIdsByConversation: {},
  messageEntities: {},
  paginationByConversation: {},
  pendingMessage: '',
  locallyCreatedConversationIds: {},
  lastReportCompletedAt: 0,
  isStoppingByConversationId: {},
  isOrchestrationActiveByConversationId: {},
})
